import { Link } from "react-router-dom";
import ComicCard from "../../../components/feature/ComicCard";
import { comics } from "../../../mocks/manga";

export default function Featured() {
  const list = comics.slice(0, 8);
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-labelledby="featured-heading">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 id="featured-heading" className="font-display text-2xl text-foreground-950 md:text-3xl">
            热门追更
          </h2>
          <p className="mt-1 text-sm text-foreground-500">高人气作品实时更新，热门漫画抢先看</p>
        </div>
        <Link to="/library" className="flex items-center gap-1 whitespace-nowrap rounded-full bg-background-100 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700">
          查看全部 <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
        {list.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}